module.exports = __webpack_public_path__ + "img/Group 966t3.d3be3920.svg";